import FundsList from './FundsList'
import FundDetail from './FundDetail'

const RouterConfig = {
  routes: [
    {
      url: '/funds',
      component: FundsList,
      exact: true
    },
    {
      url: '/funds/:id',
      component: FundDetail
    }
  ]
}

export default RouterConfig
